import React, { useState } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import apiClient from "utils/apiClient";

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [loading, setLoading] = useState(false);

  const resetForm = () => {
    setCurrentPassword("");
    setNewPassword("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await apiClient.put(
        "/identity-service/api/v1/auth/password",
        {
          currentPassword,
          newPassword,
        }
      );

      if (response.status >= 200 && response.status < 300) {
        toast.success("Password changed successfully!");
        resetForm();
      } else {
        const data = await response.json().catch(() => ({}));
        toast.error(data.message || "Failed to change password");
      }
    } catch (err) {
      toast.error("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="py-4" style={{ maxWidth: "460px", margin: "0 auto" }}>
      <div className="text-center mb-5">
        <h4 className="fw-bold">Change Password</h4>
        <p className="text-muted">
          Enter your current password and choose a new one
        </p>
      </div>

      <Form onSubmit={handleSubmit}>
        {/* Current Password */}
        <Form.Group className="mb-4">
          <Form.Label className="fw-medium">Current Password</Form.Label>
          <div className="position-relative">
            <Form.Control
              type={showCurrent ? "text" : "password"}
              placeholder="Enter current password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              disabled={loading}
              style={{ height: "48px" }}
            />
            <Button
              variant="link"
              className="position-absolute end-0 top-50 translate-middle-y text-muted"
              style={{ zIndex: 10 }}
              onClick={() => setShowCurrent(!showCurrent)}
              type="button"
            >
              {showCurrent ? <EyeSlash size={20} /> : <Eye size={20} />}
            </Button>
          </div>
        </Form.Group>

        {/* New Password */}
        <Form.Group className="mb-4">
          <Form.Label className="fw-medium">New Password</Form.Label>
          <div className="position-relative">
            <Form.Control
              type={showNew ? "text" : "password"}
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={8}
              disabled={loading}
              style={{ height: "48px" }}
            />
            <Button
              variant="link"
              className="position-absolute end-0 top-50 translate-middle-y text-muted"
              style={{ zIndex: 10 }}
              onClick={() => setShowNew(!showNew)}
              type="button"
            >
              {showNew ? <EyeSlash size={20} /> : <Eye size={20} />}
            </Button>
          </div>
        </Form.Group>

        {/* Green Button */}
        <Button
          variant="success"
          type="submit"
          className="w-100 fw-semibold"
          disabled={loading || !currentPassword || !newPassword}
          style={{
            backgroundColor: "#28a745",
            border: "none",
            height: "50px",
            fontSize: "1rem",
          }}
        >
          {loading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Changing Password...
            </>
          ) : (
            "Change Password"
          )}
        </Button>
      </Form>
    </div>
  );
};

export default ChangePassword;
